(function () {
  'use strict';

  if (window.__hhPackBuilderLoaded) return;
  window.__hhPackBuilderLoaded = true;

  function money(cents, currency) {
    var symbols = { USD: '$', CAD: '$', AUD: '$', NZD: '$', MXN: '$', EUR: '€', GBP: '£', JPY: '¥' };
    return (symbols[currency] || '$') + (Number(cents || 0) / 100).toFixed(2);
  }

  /* The hh_bundle.pricing metafield stores DOLLARS (17.99), while /cart.js and money()
     speak CENTS. Normalise once here so nothing downstream has to remember which is which.
     Without this the card rendered $17.99 as $0.18. */
  function toCents(value) {
    var n = Number(value);
    if (!isFinite(n)) return 0;
    return Math.round(n * 100);
  }

  function normaliseConfig(config) {
    if (!config) return config;
    var i;
    if (config.base_price != null) config.base_price = toCents(config.base_price);
    if (Object.prototype.toString.call(config.tiers) === '[object Array]') {
      for (i = 0; i < config.tiers.length; i += 1) {
        if (config.tiers[i] && config.tiers[i].price != null) {
          config.tiers[i].price = toCents(config.tiers[i].price);
        }
      }
    }
    return config;
  }

  function parseConfig(root) {
    var value;
    try { value = JSON.parse(root.getAttribute('data-config') || 'null'); } catch (error) { value = null; }
    if (typeof value === 'string') {
      try { value = JSON.parse(value); } catch (nestedError) { value = null; }
    }
    return value && typeof value === 'object' ? value : null;
  }

  /* Edge fade shows only while the rail actually has more to scroll to. */
  function bindRailFade(root, wrapClass, discsClass) {
    var wrap = root.querySelector('.' + wrapClass);
    var rail = root.querySelector('.' + discsClass);
    if (!wrap || !rail) return;
    function sync() {
      var more = rail.scrollWidth - rail.clientWidth - rail.scrollLeft > 8;
      if (more) {
        if (wrap.className.indexOf('is-scrollable') < 0) wrap.className += ' is-scrollable';
      } else {
        wrap.className = wrap.className.replace(/\s*is-scrollable/g, '');
      }
    }
    rail.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    window.setTimeout(sync, 0);
    sync();
  }

  function init(root) {
    if (!root || root.getAttribute('data-hh-pack-builder-ready') === 'true' || !window.HHCartTruth) return;
    root.setAttribute('data-hh-pack-builder-ready', 'true');

    var config = normaliseConfig(parseConfig(root));
    var discs = Array.prototype.slice.call(root.querySelectorAll('.hh-pb__disc'));
    var segments = Array.prototype.slice.call(root.querySelectorAll('.hh-pb__segment'));
    var ticks = Array.prototype.slice.call(root.querySelectorAll('.hh-pb__tick'));
    var draft = {}; /* This is intentionally never written by cart truth. */
    var cartState = window.HHCartTruth.get();
    var adding = false;
    var rows = root.querySelector('[data-rows]');
    var empty = root.querySelector('[data-empty]');
    var inCart = root.querySelector('[data-in-cart]');
    var inCartCount = root.querySelector('[data-in-cart-count]');
    var total = root.querySelector('[data-total]');
    var regular = root.querySelector('[data-regular]');
    var hint = root.querySelector('[data-hint]');
    var add = root.querySelector('[data-add]');
    var segs = root.querySelector('[data-segs]');
    var currency = root.getAttribute('data-currency') || 'USD';
    var feedback = '';

    function validNumber(value) { return typeof value === 'number' && isFinite(value) && value > 0; }
    function basePrice() { return config && validNumber(config.base_price) ? Number(config.base_price) : 0; }
    /* Currency. The hh_bundle.pricing metafield is USD, but the store sells in CAD, JPY and
       others. Printing metafield numbers under a local symbol would quote the wrong amount, so
       the tier is converted to a PERCENTAGE off base and applied to Shopify's own presentment
       price (product.price, already in the shopper's currency). Ported from hh-purchase-rail.js
       packTotal(). Falls back to the USD metafield only if the local price is unreadable. */
    var localBaseCents = Number(root.getAttribute('data-local-base-cents')) || 0;
    function localUnit(tierPriceUsdCents) {
      var usdBase = basePrice();
      if (!localBaseCents || !usdBase) return tierPriceUsdCents;
      if (!validNumber(tierPriceUsdCents)) return localBaseCents;
      var percentage = Number(((1 - tierPriceUsdCents / usdBase) * 100).toFixed(4));
      if (percentage <= 0) return localBaseCents;
      return localBaseCents - Math.round(localBaseCents * percentage / 100);
    }
    function localBase() { return localBaseCents || basePrice(); }


    function maxPack() { return config && validNumber(config.max_pack) ? Math.floor(config.max_pack) : 0; }
    function inCartQty() { return Number(cartState && cartState.qty) || 0; }
    function draftQty() {
      var qty = 0;
      var id;
      for (id in draft) if (Object.prototype.hasOwnProperty.call(draft, id)) qty += Number(draft[id]) || 0;
      return qty;
    }
    function headroom() { return Math.max(0, maxPack() - inCartQty()); }
    function tierFor(quantity) {
      var tiers = config && Array.isArray(config.tiers) ? config.tiers : [];
      var index;
      var tier;
      var maximum;
      for (index = 0; index < tiers.length; index += 1) {
        tier = tiers[index];
        maximum = tier && (tier.max === null || typeof tier.max === 'undefined') ? Infinity : Number(tier && tier.max);
        if (tier && validNumber(tier.price) && Number(tier.min) <= quantity && quantity <= maximum) return tier;
      }
      return null;
    }
    function setAddDisabled(disabled) { add.setAttribute('aria-disabled', disabled ? 'true' : 'false'); }
    function setDraft(id, amount) {
      if (amount > 0) draft[id] = amount;
      else delete draft[id];
    }
    function renderRows() {
      var any = false;
      var index;
      var disc;
      var id;
      var count;
      var row;
      var name;
      var dot;
      var stepper;
      var minus;
      var countOut;
      var plus;
      while (rows.firstChild) rows.removeChild(rows.firstChild);
      for (index = 0; index < discs.length; index += 1) {
        disc = discs[index];
        id = disc.getAttribute('data-variant-id');
        count = Number(draft[id]) || 0;
        disc.className = disc.className.replace(' has-count', '');
        disc.querySelector('[data-disc-count]').textContent = count ? String(count) : '';
        if (count) {
          any = true;
          disc.className += ' has-count';
          row = document.createElement('div'); row.className = 'hh-pb__row'; row.setAttribute('data-row-id', id);
          name = document.createElement('div'); name.className = 'hh-pb__row-name'; name.textContent = disc.getAttribute('data-name') || '';
          dot = document.createElement('span'); dot.className = 'hh-pb__row-dot'; dot.style.backgroundImage = disc.querySelector('.hh-pb__disc-image').style.backgroundImage; name.insertBefore(dot, name.firstChild);
          stepper = document.createElement('div'); stepper.className = 'hh-pb__row-stepper';
          minus = document.createElement('button'); minus.type = 'button'; minus.setAttribute('data-draft-change', '-1'); minus.setAttribute('aria-label', 'Remove one ' + (disc.getAttribute('data-name') || '')); minus.innerHTML = '&minus;';
          countOut = document.createElement('span'); countOut.textContent = String(count);
          plus = document.createElement('button'); plus.type = 'button'; plus.setAttribute('data-draft-change', '1'); plus.setAttribute('aria-label', 'Add one ' + (disc.getAttribute('data-name') || '')); plus.textContent = '+';
          if (cartState.status !== 'resolved' || adding || draftQty() >= headroom()) plus.setAttribute('aria-disabled', 'true');
          stepper.appendChild(minus); stepper.appendChild(countOut); stepper.appendChild(plus); row.appendChild(name); row.appendChild(stepper); rows.appendChild(row);
        }
      }
      if (any) empty.setAttribute('hidden', 'hidden'); else empty.removeAttribute('hidden');
    }
    function renderMeter(combined, canPrice) {
      var previous = 0;
      var index;
      var min;
      var fill;
      var progress;
      var cap;
      var second;
      var last;
      for (index = 0; index < segments.length; index += 1) {
        min = Number(segments[index].getAttribute('data-min'));
        fill = segments[index].querySelector('i');
        progress = min > previous ? Math.max(0, Math.min(1, (combined - previous) / (min - previous))) : 0;
        if (fill) fill.style.width = Math.round(progress * 100) + '%';
        previous = min;
      }
      for (index = 0; index < ticks.length; index += 1) {
        min = Number(ticks[index].getAttribute('data-min'));
        if (combined >= min) ticks[index].className = ticks[index].className + (ticks[index].className.indexOf(' hit') === -1 ? ' hit' : '');
        else ticks[index].className = ticks[index].className.replace(' hit', '');
        if (canPrice) {
          var badgeTier = tierFor(min);
          var badge = ticks[index].querySelector('[data-badge-price]');
          if (badge && badgeTier) badge.textContent = money(localUnit(Number(badgeTier.price)), currency) + ' each';
        } else {
          var hiddenBadge = ticks[index].querySelector('[data-badge-price]');
          if (hiddenBadge) hiddenBadge.innerHTML = '&nbsp;';
        }
      }
      if (!segs || !segments.length) return;
      cap = Number(segments[segments.length - 1].getAttribute('data-min'));
      second = ticks[1] && combined >= Number(ticks[1].getAttribute('data-min'));
      last = ticks.length && combined >= Number(ticks[ticks.length - 1].getAttribute('data-min'));
      if (last) segs.style.boxShadow = 'inset 0 1px 2px rgba(0,0,0,.15),0 0 18px rgba(176,235,116,.95)';
      else if (second) segs.style.boxShadow = 'inset 0 1px 2px rgba(0,0,0,.15),0 0 ' + Math.round(12 + 6 * Math.max(0, Math.min(1, combined / cap))) + 'px rgba(154,227,63,.82)';
      else segs.style.boxShadow = 'inset 0 1px 2px rgba(0,0,0,.15),0 0 ' + Math.round(4 + 10 * Math.max(0, Math.min(1, combined / cap))) + 'px rgba(242,24,250,' + (0.15 + 0.45 * Math.max(0, Math.min(1, combined / cap))).toFixed(2) + ')';
    }
    function render() {
      /* Taken once and cleared here so an add outcome survives whichever branch
         renders next, and cannot linger into a later render. Matches the
         pendingHint idiom in assets/hh-buy-card.js. Named `note`, not `staged`:
         `staged` is this file's pack quantity. */
      var note = feedback;
      feedback = '';
      var status = cartState && cartState.status;
      var staged = draftQty();
      var cartQty = inCartQty();
      var combined = cartQty + staged;
      var room = headroom();
      var tier = tierFor(combined);
      var validDraft = staged > 0 && staged <= room;
      var canPrice = status === 'resolved' && !adding && validDraft && !!basePrice() && !!tier;
      var canAdd = canPrice;
      if (inCart) {
        if (cartQty > 0) { inCart.removeAttribute('hidden'); if (inCartCount) inCartCount.textContent = String(cartQty); }
        else inCart.setAttribute('hidden', 'hidden');
      }
      discs.forEach(function (disc) {
        if (disc.getAttribute('data-available') !== 'true' || status !== 'resolved' || adding || draftQty() >= room) {
          disc.setAttribute('aria-disabled', 'true');
        } else {
          disc.removeAttribute('aria-disabled');
        }
      });
      renderRows();
      renderMeter(combined, status === 'resolved' && !adding);
      if (status !== 'resolved' || adding) {
        total.textContent = 'Updating cart'; regular.innerHTML = '&nbsp;';
        hint.textContent = note || (status === 'unresolved' ? 'Cart could not be verified. Refresh to continue.' : 'Updating cart. Add to Cart will be ready in a moment.');
        add.textContent = staged ? 'Add ' + staged + ' to Cart' : 'Pick a color'; setAddDisabled(true); return;
      }
      if (staged > room) {
        total.textContent = 'Cart changed'; regular.innerHTML = '&nbsp;';
        hint.textContent = note || 'Cart changed. Remove 1 from your pack or edit your cart to continue.';
        add.textContent = 'Add ' + staged + ' to Cart'; setAddDisabled(true); return;
      }
      if (!staged) {
        /* A price slot should hold a price. Sentence copy at 40px read as a heading, and
           "Add 0 to Cart" tells the shopper what they cannot do rather than what to do. */
        total.textContent = money(0, currency); regular.innerHTML = '&nbsp;';
        hint.textContent = note || 'Tap a color to add it to your pack.';
        add.textContent = 'Pick a color'; setAddDisabled(true); return;
      }
      if (!basePrice() || !tier) {
        total.textContent = 'Pricing unavailable'; regular.innerHTML = '&nbsp;';
        hint.textContent = note || 'Pricing could not be verified. Please refresh to continue.';
        add.textContent = 'Add ' + staged + ' to Cart'; setAddDisabled(true); return;
      }
      total.textContent = money(localUnit(Number(tier.price)) * staged, currency);
      if (localUnit(Number(tier.price)) < localBase()) {
        regular.innerHTML = '<span class="hh-pb__sr">Regular price </span><s>' + money(localBase() * staged, currency) + '</s>';
      } else {
        regular.innerHTML = '&nbsp;';
      }
      hint.textContent = note || '\u00a0';
      add.textContent = 'Add ' + staged + ' to Cart'; setAddDisabled(!canAdd);
    }
    function addOne(disc) {
      var id;
      if (!disc || disc.getAttribute('data-available') !== 'true' || cartState.status !== 'resolved' || adding) return;
      if (draftQty() >= headroom()) { render(); return; }
      id = disc.getAttribute('data-variant-id'); setDraft(id, (Number(draft[id]) || 0) + 1); render();
    }
    function replaceDrawer(data) {
      var html = data && data.sections && data.sections['cart-drawer-section'];
      var wrap;
      var fresh;
      var drawer;
      if (!html) { window.location.reload(); return false; }
      wrap = document.getElementById('shopify-section-cart-drawer-section');
      fresh = new DOMParser().parseFromString(html, 'text/html').getElementById('shopify-section-cart-drawer-section');
      if (wrap && fresh) wrap.replaceWith(fresh);
      drawer = document.getElementById('cart-drawer');
      if (drawer) { if (typeof drawer.open === 'function') drawer.open(); else drawer.setAttribute('open', ''); }
      return true;
    }
    function standardCart(cart) {
      var currencyCode = cart && cart.currency ? String(cart.currency) : '';
      return {
        id: cart && cart.token ? String(cart.token) : '',
        totalQuantity: Number(cart && cart.item_count) || 0,
        cost: { totalAmount: { amount: ((Number(cart && cart.total_price) || 0) / 100).toFixed(2), currencyCode: currencyCode } },
        lines: cart && Array.isArray(cart.items) ? cart.items.map(function (item) {
          return { id: String(item.key || item.id || ''), quantity: Number(item.quantity) || 0, cost: { totalAmount: { amount: ((Number(item.final_line_price) || 0) / 100).toFixed(2), currencyCode: currencyCode } } };
        }) : []
      };
    }
    function dispatchCartUpdate(items, data, cart) {
      var detail = { didError: false, itemCount: Number(cart && cart.item_count) || 0, items: cart && cart.items, sections: data.sections, source: 'hh-pack-builder' };
      var event = new Event('shopify:cart:lines-update', { bubbles: true });
      event.action = 'add'; event.context = 'cart';
      event.lines = items.map(function (item) { return { merchandiseId: String(item.id), quantity: item.quantity }; });
      event.detail = { source: 'hh-pack-builder' };
      event.promise = Promise.resolve({ cart: standardCart(cart), detail: detail });
      (document.querySelector('#shopify-section-cart-drawer-section cart-items-component') || document).dispatchEvent(event);
    }
    /* Shared tail for every outcome the server may have applied but we could not read
       back. Clearing the pack is what stops a second tap from ordering what already
       landed: the message alone does not, because the button would still read
       "Add 3 to Cart" and still be live. Cart truth is stale or unresolved here and
       headroom() is computed from it, so re-read it. Without that a later visibility or
       pageshow refresh resolves the old quantity and re-arms the untouched pack. The
       outcome is restated after the read because refresh() renders as it goes and
       consumes whatever is staged. */
    function unconfirmed(message) {
      adding = false;
      draft = {};
      feedback = message;
      render();
      /* Same resolved-promise boundary as verify(), and for the same reason: refresh()
         setStates before it returns, setState notifies every subscriber on the spot, and
         a throw from another section's render would escape a .catch that is not attached
         until afterwards. */
      Promise.resolve().then(function () {
        return window.HHCartTruth.refresh();
      }).catch(function () {}).then(function () {
        feedback = message;
        render();
      });
    }
    /* A 2xx that is not JSON is not an add. A challenged request is answered with an HTML
       page and fetch follows the redirect, so response.ok on its own would report a
       confirmed add for a request the server refused, and the pack would be cleared for
       nothing. A truncated JSON body still carries the JSON content type, so the case
       this guard exists to protect stays protected. */
    function contentType(response) {
      var type = response.headers && response.headers.get ? response.headers.get('content-type') : '';
      return String(type || '');
    }
    function addedJson(response) {
      return contentType(response).indexOf('json') > -1;
    }
    /* Only an HTML body earns the benefit of the doubt. Classifying every non-JSON 2xx
       as a challenge would extend it to a response with no content-type at all, and an
       unknown answer is not evidence that nothing landed. json adds, html was
       intercepted, anything else is unknowable and clears the pack. */
    function challengePage(response) {
      return contentType(response).indexOf('html') > -1;
    }
    /* Started from a resolved promise so afterAdd() can never throw SYNCHRONOUSLY into
       the caller. It refreshes cart truth, and setState notifies every subscriber on the
       spot, so a throw inside any other section's render would otherwise escape. From
       inside a .catch handler there is nothing left to catch it, and `adding` would stay
       true, which is the dead Add button this change exists to remove. */
    function verify(items, data, rejected) {
      return Promise.resolve().then(function () {
        return window.HHCartTruth.afterAdd(items);
      }).then(function (report) {
        return { data: data, report: report, rejected: rejected };
      });
    }
    function addPack() {
      var items = [];
      var id;
      /* Once the POST lands, nothing downstream may claim the add failed. The pack is
         already in the drawer, so "that did not go through" reads as a contradiction
         and invites a second add of every disc. Same guard as assets/hh-buy-card.js. */
      var posted = false;
      /* A refused add is a separate case from a failed one: Shopify can land part of the
         pack and still answer 422, so if the cart read below also fails we know neither
         what landed nor that nothing did. */
      var rejected = false;
      /* A 2xx that is not JSON is a challenge or password interstitial. Those answer
         BEFORE the request reaches the cart, so nothing landed, which is the one
         unreadable outcome we can still keep the pack through. */
      var challenged = false;
      /* What the cart held before the POST, keyed by variant, so the reconcile below
         measures against a point in time we know preceded the add. */
      var baseline = {};
      var known;
      if (add.getAttribute('aria-disabled') === 'true' || adding) return;
      for (id in draft) if (Object.prototype.hasOwnProperty.call(draft, id) && draft[id] > 0) items.push({ id: Number(id), quantity: draft[id] });
      if (!items.length) return;
      known = (cartState && cartState.byVariant) || {};
      for (id in draft) if (Object.prototype.hasOwnProperty.call(draft, id)) baseline[String(id)] = Number(known[String(id)]) || 0;
      adding = true; render();
      /* The pack is kept only when the outcome is KNOWN to have left it unadded: a
         parsed 2xx confirms it outright, and a rejected add is measured against the
         cart as it stood before the POST. Every unknowable outcome clears it, because a
         pack left staged beside a live button is what turns an unconfirmed add into a
         second order. */
      function settle(transaction) {
        var index;
        var item;
        var id;
        var after;
        var wanted;
        var landed;
        var remaining = 0;
        var requested = 0;
        /* Drawer replacement failed after a successful POST. This used to return
           without clearing `adding`, leaving Add disabled behind the reload. */
        if (!transaction) { unconfirmed('Pack added. We could not refresh the display, so please check your cart.'); return; }
        after = (transaction.report.state && transaction.report.state.byVariant) || {};
        for (index = 0; index < items.length; index += 1) {
          item = items[index];
          id = String(item.id);
          wanted = Number(item.quantity) || 0;
          /* A parsed 2xx is its own proof: Shopify takes every requested line or none,
             so the response is better evidence than a cart delta, which cannot tell our
             add apart from another tab removing the same colour at the same moment. A
             delta of zero there would leave the whole pack staged over units that
             definitely posted. The delta is used only where there is no response to
             trust, and then it is measured from the quantities read BEFORE the POST:
             afterAdd() snapshots its own baseline when verification starts, so a
             refresh landing between the commit and this point would already contain the
             new units and report that nothing had happened. */
          landed = transaction.rejected
            ? Math.min(wanted, Math.max(0, (Number(after[id]) || 0) - (Number(baseline[id]) || 0)))
            : wanted;
          setDraft(id, Math.max(0, (Number(draft[id]) || 0) - landed));
          requested += wanted;
          remaining += Math.max(0, wanted - landed);
        }
        if (transaction.rejected) {
          /* The read succeeded, so "still here" is now a verified statement rather than
             a guess. No cart event is dispatched on this path: the report is fresh so
             this section is right, but we hold no drawer sections to hand anyone else. */
          /* Worded from what is actually left, not from the fact of the rejection. The
             middle case is a real partial. The last one is the delta crediting us with
             units another tab added in the same window: the pack is empty, so promising
             that the remaining choices are still in it would describe nothing. */
          feedback = remaining >= requested
            ? 'That did not go through. Your pack is still here.'
            : (remaining
              ? 'Some colors could not be added. The remaining choices are still in your pack.'
              : 'We could not confirm that. Please check your cart before adding again.');
          adding = false; render();
          return;
        }
        feedback = 'Pack added to your cart.';
        /* render() before the dispatch. A listener that synchronously moves cart truth
           would otherwise render first and consume the message. */
        adding = false; render(); dispatchCartUpdate(items, transaction.data, transaction.report.state.raw);
      }
      fetch(root.getAttribute('data-cart-add-url'), {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items, sections: 'cart-drawer-section', sections_url: window.location.pathname })
      }).then(function (response) {
        /* A rejected add is not an unchanged cart. Shopify documents that a request for
           more than the available stock adds the maximum available and STILL answers 422,
           so "your pack is still here" would invite a second add of whatever did land.
           Read the cart back either way and let the reconcile below subtract it.
           https://shopify.dev/docs/api/ajax/reference/cart */
        if (!response.ok) { rejected = true; return verify(items, null, true); }
        posted = addedJson(response);
        challenged = challengePage(response);
        return response.json().then(function (data) {
          if (!replaceDrawer(data)) return null;
          return verify(items, data, false);
        });
      })
        .then(settle)
        .catch(function () {
          if (posted) { unconfirmed('Pack added. We could not refresh the display, so please check your cart.'); return; }
          if (rejected) { unconfirmed('We could not confirm that. Please check your cart before adding again.'); return; }
          /* No response at all. That does not prove the request never reached Shopify:
             the cart can commit the add and the reply still be lost, and guessing "it
             failed" there hands back a full pack to re-add. Read the cart and reconcile
             against what is actually in it. */
          rejected = true;
          verify(items, null, true).then(settle).catch(function () {
            /* Both reads failed, so nothing is knowable. It is tempting to read that as
               proof the connection was down and nothing landed, but a POST can commit
               and the reply be lost on the same dead connection, and the cart is only
               held closed until the next successful refresh, which then re-arms an
               untouched pack. Probability is not a safe basis for an ordering gate, so
               the pack goes. Rebuilding it costs a few taps; the other way costs a
               duplicate order. */
            /* The one exception: a challenge answered before the cart was touched, so
               nothing landed however the read went, and clearing the pack would cost a
               real order for nothing. A network failure carries no such guarantee. */
            if (challenged) {
              adding = false;
              feedback = 'That did not go through. Your pack is still here.';
              render();
              return;
            }
            unconfirmed('We could not confirm that. Please check your cart before adding again.');
          });
        });
    }

    discs.forEach(function (disc) { disc.addEventListener('click', function () { addOne(disc); }); });
    root.addEventListener('click', function (event) {
      var target = event.target;
      var change;
      var row;
      var id;
      while (target && target !== root && target.getAttribute('data-draft-change') === null && target.getAttribute('data-add') === null) target = target.parentNode;
      if (!target || target === root) return;
      if (target.getAttribute('data-add') !== null) { addPack(); return; }
      if (target.getAttribute('aria-disabled') === 'true') return;
      change = Number(target.getAttribute('data-draft-change')); row = target;
      while (row && row !== root && !row.getAttribute('data-row-id')) row = row.parentNode;
      if (!row || row === root) return;
      id = row.getAttribute('data-row-id');
      if (change > 0 && (cartState.status !== 'resolved' || adding || draftQty() >= headroom())) return;
      setDraft(id, Math.max(0, (Number(draft[id]) || 0) + change)); render();
    });
    window.HHCartTruth.subscribe(function (nextState) { cartState = nextState; render(); });
    render();
  }

  function initAll(scope) {
    /* fade state is bound per instance inside init via the call below */
    var context = scope && scope.querySelectorAll ? scope : document;
    Array.prototype.forEach.call(context.querySelectorAll('[data-hh-pack-builder]'), function (root) {
      init(root);
      bindRailFade(root, 'hh-pb__discs-wrap', 'hh-pb__discs');
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  else initAll(document);
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
}());
